/**
 * 群聊陪伴 H5 · 组件内部配置（非对外 props）。
 * 改这里即可微调视觉，无需改业务逻辑。
 */

/** 「今日还剩…」额度提示条（紧贴输入区外侧上方、满宽） */
export interface CompanionQuotaBarConfig {
  /** 行高度（px）；同时作为最小高度 */
  height: number;
  /** 提示文字字号（px） */
  fontSize: number;
  /** 提示文字颜色（额度态） */
  color: string;
}

/**
 * 回复/引用模式提示条（替换额度条位置）。
 * 文案形如：回复 姓名 ：内容摘要；姓名单独浅蓝，其余用 color。
 */
export interface CompanionReplyTipBarConfig {
  /** 行高度（px） */
  height: number;
  /** 字号（px） */
  fontSize: number;
  /** 「回复」「：」与正文摘要颜色（灰色） */
  color: string;
  /** 被回复对象姓名颜色（浅蓝） */
  nameColor: string;
  /** 「取消」文字按钮颜色（浅蓝） */
  cancelColor: string;
}

/** 消息旁「回复 / 引用」文字按钮 */
export interface CompanionReplyActionConfig {
  /** 浅蓝色文字 */
  color: string;
  /** 字号（px） */
  fontSize: number;
}

/**
 * 气泡下方微信式引用条（气泡外，无底色）。
 * 自己消息：右侧竖线；别人消息：左侧竖线。
 */
export interface CompanionMsgQuoteConfig {
  /** 字号（px） */
  fontSize: number;
  /** 灰色文字 */
  color: string;
  /** 竖线颜色 */
  railColor: string;
  /** 竖线宽度（px） */
  railWidth: number;
  /** 文字与竖线间距（px） */
  railGap: number;
  /**
   * 被引用消息展示最大宽度（px）。
   * 短内容随文字收缩；长内容在此宽度内换行（再按行数截断）。
   */
  width: number;
  /** 与气泡间距（px） */
  marginTop: number;
}

export const COMPANION_QUOTA_BAR = {
  height: 20,
  fontSize: 10,
  color: "rgb(41, 58, 255)",
} as const satisfies CompanionQuotaBarConfig;

export const COMPANION_REPLY_TIP_BAR = {
  height: 28,
  fontSize: 12,
  color: "#999999",
  nameColor: "#6EB6FF",
  cancelColor: "#6EB6FF",
} as const satisfies CompanionReplyTipBarConfig;

export const COMPANION_REPLY_ACTION = {
  color: "#6EB6FF",
  fontSize: 12,
} as const satisfies CompanionReplyActionConfig;

export const COMPANION_MSG_QUOTE = {
  fontSize: 12,
  color: "#b2b2b2",
  railColor: "#d0d0d0",
  railWidth: 2,
  railGap: 8,
  width: 220,
  marginTop: 4,
} as const satisfies CompanionMsgQuoteConfig;

/**
 * 会话列表图片缩略图：固定高度占位，宽度按原图等比。
 * 未加载时骨架同高，避免滚底后图片撑开导致末条被挡。
 */
export interface CompanionMsgThumbConfig {
  /** 缩略图固定高度（px） */
  height: number;
  /** 未加载时骨架底色 */
  skeletonBg: string;
}

export const COMPANION_MSG_THUMB = {
  height: 150,
  skeletonBg: "#ebebeb",
} as const satisfies CompanionMsgThumbConfig;

/** 群聊表情面板（底部弹出的贴纸区） */
export interface CompanionStickerPanelConfig {
  /** 单个表情展示边长（px） */
  stickerSize: number;
  /** 网格列数 */
  columns: number;
  /** 表情之间的间距（px） */
  gap: number;
}

export const COMPANION_STICKER_PANEL = {
  stickerSize: 64,
  columns: 4,
  gap: 12,
} as const satisfies CompanionStickerPanelConfig;
